import { I18n } from 'react-redux-i18n';
import booleanContains from '@turf/boolean-contains';

import {
  maxLength,
  required,
  conditionalValidation,
  validPolygon
} from '../../utils/validation';
import { LOCATION_TYPES } from '../../constants/areas';


//to explicit to be in validations
export const AreaZonesValidation = (values) => {
    let {zones} = values;
    if (!zones) {
      return;
    }
    let geometry = {
      type: 'Polygon',
      coordinates: [values.polygon]
    };
    let r = true;
    for(let i=0;i<zones.length;i++){
      let zp = {
        type: 'Polygon',
        coordinates: [zones[i]]
      }
      r = booleanContains(geometry, zp);
      if(!r){
        break;
      }
    }
    let error = I18n.t('error.pointNotInPolygon', {
        fieldName: I18n.t('models.zone.area'),
        parentFieldName: I18n.t('models.area.polygon')
      });
    return !r && error;
  };

export const AreaValidations = {
  name: [required('models.area.name'), maxLength(24, 'models.area.name')],
  site: required('models.area.site'),
  file: required('models.area.file'),
  location: required('models.area.location'),
  geoReferenced: conditionalValidation(
    values => values.location === LOCATION_TYPES.INDOOR,
    [required('models.area.geoReferenced')]
  ),
  polygon: [
    required('models.area.polygon'),
    validPolygon('models.area.polygon')
  ],
  polygonWithZones: [
    required('models.area.polygon'),
    validPolygon('models.area.polygon'),
    AreaZonesValidation]
};

class Serializer {
  normalize = data => {
    let al = data.assetInfo.metadata.props.areaLocation ? data.assetInfo.metadata.props.areaLocation.toLowerCase(): '';
    return {
      id: data.id,
      account: data.account && {
        id: data.account.id,
        href: data.account.href
      },
      href: data.self.href,
      name: data.value,
      indoorMapping: data.assetInfo.metadata.props.indoorMapping
        ? { id: data.assetInfo.metadata.props.indoorMapping }
        : {},
      site: {
        id: data.assetInfo.metadata.props.siteId
      },
      location: al,
      geoReferenced: data.assetInfo.metadata.props.geoReferenced,
      locationCount: +(data.assetInfo.metadata.props.locationCount || 0),
      zoneCount: +(data.assetInfo.metadata.props.zoneCount || 0),
      polygon: data.assetInfo.metadata.props.points
        ? data.assetInfo.metadata.props.points
            .split(';')
            .map(point => point.split(',').map(n => +n))
        : null
    };
  };
  serialize = area => {
    let geo = 'true'
    if(area.location === LOCATION_TYPES.INDOOR){
      geo = 'false'
    }
    let al = area.location ? area.location.toLowerCase() : '';
    let serializedArea = {
      configValue: area.name,
      properties: {
        siteId: area.site.id,
        areaLocation: al,
        geoReferenced: geo,
        points: area.polygon
          ? area.polygon.map(point => point.join(',')).join(';')
          : ''
      }
    };
    if (area.indoorMapping) {
      serializedArea.properties.indoorMapping = area.indoorMapping.id;
    }
    return serializedArea;
  };
  serializeForUpdate = area=>{
    let serializedArea = {
        name: area.name
    };
    return serializedArea;
  }
}

export const AreaSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/area/index.js